import { Component } from '@angular/core';

@Component({
  selector: 'app-style-config',
  templateUrl: './style-config.component.html',
  styleUrls: ['./style-config.component.scss']
})
export class StyleConfigComponent {
}
